import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import {
  GAMES_ADD_PATH,
  GAMES_PATH,
  GAMES_UPDATE_PATH,
} from "utils/constants/paths";

const Games = Loadable(React.lazy(() => import("./View")));
const GamesAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate"))
);

export const GamesRoute: IRouteItem = {
  path: GAMES_PATH,
  element: React.createElement(Games),
  name: "Games",
  iconName: "Share",
  accessKeys: ["Support", "ContentCreator", "Analyst", "SystemUserManager"],
  children: [
    {
      name: "Add / Update",
      path: GAMES_ADD_PATH,
      element: React.createElement(GamesAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: GAMES_UPDATE_PATH,
      element: React.createElement(GamesAddOrUpdate),
      showInDrawer: false,
    },
  ],
};
